import { api, apiMipe } from '@/core/api/';

const BaseUrl = '/api/account';

export const getUserMenu = async () => {
  try {
    const { data } = await api.get(`${BaseUrl}/sitemap/`);
    return data;
  } catch {
    return [];
  }
};

export const getAdditionalProfileInfo = async () => {
  try {
    const { data } = await api.get(`${BaseUrl}/getprofileinformation/`);
    if (data) {
      const { companies, permissions, user } = data;

      return {
        companies: (companies || []).map(
          ({ id, name, socialSecurityNo, isMainCompany }) => ({
            id,
            name,
            ssn: socialSecurityNo,
            main: isMainCompany,
          })
        ),
        permissions,
        userProfile: user,
      };
    }

    return null;
  } catch {
    return null;
  }
};

export const changeUserPassword = (args) => {
  return api.post(`${BaseUrl}/changepassword/`, args);
};

export const completeUserAgreement = (userId) =>
  api.post(`${BaseUrl}/useragreement`, { userId });

export const updateMyProfile = (params) =>
  apiMipe.put(`api/userprofiles/myprofile`, params);
